import { render, staticRenderFns } from "./ImgSVG.vue?vue&type=template&id=571e267e"
import script from "./ImgSVG.vue?vue&type=script&lang=js"
export * from "./ImgSVG.vue?vue&type=script&lang=js"
import style0 from "./ImgSVG.vue?vue&type=style&index=0&id=571e267e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports